'use client'
import React, {useState, useEffect, useRef, useCallback} from 'react'
import style from './erp-carousel.module.scss'
import {BsCircle, BsCircleFill} from 'react-icons/bs';
import screenImg from '../../../public/media/mkg-website/slider_top_layer_scherm_kaal_720-642.png'
import SvgPijlRechts from "components/Svg/SvgPijlRechts";
import {isMobile} from 'react-device-detect';
import axios from "axios";
import Image from 'next/image'

const ErpCarousel = ({mkgVariant}) => {
    const [itemsCarousel, setItemsCarousel] = useState([])
    const ref = useRef()
    const carouselRef = useRef(null);
    const [refParams, setRefParams] = useState(null);//{object}
    const [enableScroll, setEnableScroll] = useState(true)
    const [enableWheel, setEnableWheel] = useState(false)
    const [activeWheelIndex, setActiveWheelIndex] = useState(null) // int
    const [wActive, setWActive] = useState(true)
    const [items, setItems] = useState([])
    useEffect(() => {
        const url = mkgVariant === 5 ? `${process.env.NEXT_PUBLIC_BACKEND}/api/weergave/15` : `${process.env.NEXT_PUBLIC_BACKEND}/api/weergave/14`
        axios.get(url)
            .then((res) => {
                setItems(res.data)
            })
    }, [])

    useEffect(() => {
        if (items.length === 0) return;
        setItemsCarousel([...items].map((item, index) => {
            item.active = index === 0
            return item
        }))
    }, [items, mkgVariant])

    const handleNavigationCLick = (index) => {
        const items = [...itemsCarousel].map((item, i) => {
            item.active = index === i
            return item
        })
        setItemsCarousel(items)
    }
    const handleArrow = (index, boolean) => {
        setItemsCarousel([...itemsCarousel.map((item, i) => {
            item.active = boolean ? index + 1 === i : index - 1 === i
            return item
        })])
    }

    useEffect(() => {
        if (activeWheelIndex === null) return
        handleNavigationCLick(activeWheelIndex)
    }, [activeWheelIndex])


    const handleWheel = useCallback((event) => {
        if (!wActive) return
        const indexes = itemsCarousel.length - 1;
        if (event.deltaY > 0) {
            if (activeWheelIndex !== null) {
                setActiveWheelIndex((prevIndex) => {
                    if (prevIndex >= indexes) {
                        setEnableScroll(false)
                        setWActive(false)
                        return indexes;
                    }
                    return prevIndex + 1;
                });
            } else {
                setTimeout(() => {
                    setActiveWheelIndex(0);
                }, 700);

            }
        } else {
            if (activeWheelIndex !== null) {
                if (activeWheelIndex === 0) {
                    setActiveWheelIndex(null)
                    setWActive(false)
                    setEnableScroll(false)
                }
                setActiveWheelIndex((prevIndex) => {
                    if (prevIndex <= 0) {
                        return 0;
                    }
                    return prevIndex - 1;
                });
            } else {
                setWActive(false)
                setEnableScroll(false)
            }
        }
    }, [wActive, activeWheelIndex, itemsCarousel]);


    useEffect(() => {
        if (isMobile) return
        if (enableWheel) {
            document.addEventListener('wheel', handleWheel);
        } else {
            document.removeEventListener('wheel', handleWheel);
        }
        return () => {
            document.removeEventListener('wheel', handleWheel);
        };
    }, [enableWheel, handleWheel]);


    useEffect(() => {
        if (!refParams || isMobile) return
        if (refParams.bottom <= (refParams.windowHeight + 100) && enableScroll) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '17px';
            document.body.style.backgroundColor = 'lightgray'
            setEnableWheel(true)
            setWActive(true)
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
            document.body.style.backgroundColor = 'auto'
        }

        if ((refParams.top + 200) > refParams.windowHeight && !enableScroll && !wActive) {
            setEnableScroll(true)
            setActiveWheelIndex(null)
            setItemsCarousel([...itemsCarousel].map((item, index) => {
                item.active = index === 0
                return item
            }))
        }
    }, [refParams, enableScroll])


    useEffect(() => {
        if (isMobile) return
        const handleScroll = () => {
            const params = {
                bottom: ref.current?.getBoundingClientRect().bottom,
                top: ref.current?.getBoundingClientRect().top,
                windowHeight: window.innerHeight
            }
            setRefParams(params)
        }
        if (ref.current) {
            if (typeof window === "undefined") return;
            window.addEventListener('scroll', (event) => handleScroll(event));
        }
        return () => {
            if (typeof window === "undefined") return;
            window.removeEventListener('scroll', (event) => handleScroll(event));
        };
    }, [])


    return <div style={{paddingTop: '100px'}}>
        {isMobile ? <div className={style.carouselContainerMobile}>

            {itemsCarousel.length > 0 && itemsCarousel.map((item) => {

                return <div className={style.itemMobile}>
                    {/*onContextMenu={(e) => handleContextMenu(e, item, index, array)}*/}
                    <div className={style.imgCont}>
                        <Image className={style.imgSetting} src={screenImg} alt={'screen'}/>
                        <img src={`${process.env.NEXT_PUBLIC_BACKEND}/api/wiki/${item.voorblad_wiki_id}/NL/media`} alt={'pr'}/>
                        {/*`${process.env.NEXT_PUBLIC_BACKEND}/mijn-mkg/media/
                          ${items[0].overzicht_wiki.content_media.media.id}`*/}
                        {/*rest/wiki/${item.voorblad_wiki_id}/NL/media*/}
                    </div>
                    <div className={style.header}>{item.content_gepubliceerd.titel}</div>
                    <div className={style.spacertxt}></div>
                    <div className={style.body} dangerouslySetInnerHTML={{__html: item.content_gepubliceerd.bericht}}/>
                </div>
            })}
        </div> : <div className={style.carouselContainer} ref={ref} id={'refTest'}>
            <div className={style.carouselWrapper} ref={carouselRef}>
                {itemsCarousel.length > 0 && itemsCarousel.map((item, index, array) => {


                    const firstItem = index === 0 && item.active
                    const lastItem = index === array.length - 1 && item.active


                    return <div key={'erpCarousel' + index} className={style.carouselItem} style={{display: item.active ? 'flex' : 'none'}}>
                                {/*onContextMenu={(e) => handleContextMenu(e, item, index, array)}>*/}
                        <div className={style.navigatie}>
                            <div onClick={() => index > 0 && handleArrow(index, false)}
                                 style={{opacity: firstItem ? '0.5' : '1.0'}} className={style.arrowTop}><SvgPijlRechts
                                fill={'#FFFFFF'}/></div>
                            {array.map((item, index) => {
                                return <div key={'erpcaroucel_' + index} onClick={() => handleNavigationCLick(index)}>
                                    {item.active ? <BsCircleFill/> : <BsCircle/>}
                                </div>
                            })}
                            <div onClick={() => index < array.length - 1 && handleArrow(index, true)}
                                 style={{opacity: lastItem ? '0.5' : '1.0'}} className={style.arrowBot}><SvgPijlRechts
                                fill={'#FFFFFF'}/></div>
                        </div>

                        <div className={style.textContainer}>
                            <div className={style.header}>{item.content_gepubliceerd.titel}</div>
                            <div className={style.spacertxt}></div>
                            <div className={style.body}
                                 dangerouslySetInnerHTML={{__html: item.content_gepubliceerd.bericht}}/>
                        </div>

                        <div className={style.imgContainer}>
                            {/*<div className={style.screenContainer}></div>*/}
                            <Image className={style.imgSetting} src={screenImg} alt={'screen'}/>
                            <img className={style.imgSlide} src={`${process.env.NEXT_PUBLIC_BACKEND}/api/wiki/${item.voorblad_wiki_id}/NL/media`}
                                 alt={'pr'}/>
                        </div>

                    </div>
                })}
            </div>


        </div>}

    </div>
}
export default ErpCarousel